import {Component, OnInit, HostListener} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {Location} from '@angular/common';
import {NgxSpinnerService} from 'ngx-spinner';
import {NbDialogService} from '@nebular/theme';
import {HttpParams} from '@angular/common/http';
import {RestringirMccClienteService} from './restringir-mcc-cliente.service';

@Component({
  selector: 'ngx-restringir-mcc-cliente',
  templateUrl: './restringir-mcc-cliente.component.html',
  styleUrls: ['./restringir-mcc-cliente.component.scss'],
})
export class RestringirMccClienteComponent implements OnInit {
  public spinnerLoad: boolean = false;
  public formMccCliente = null;
  public inpMcc = null;
  public listProdutos: any = [];
  public produto: any = null;
  public blocked: any = [];
  public unblocked: any = [];
  public resetedBlocked: any = [];
  public resetedUnblocked: any = [];
  public innerWidth: any;
  public checkedUnblockedList: any = [];
  public checkedBlockedList: any = [];

  constructor(
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private service: RestringirMccClienteService,
    private location: Location,
    private spinnerService: NgxSpinnerService,
    private dialogService: NbDialogService,
    private router: Router
  ) {
    this.formMccCliente = this.formBuilder.group({
      inpMcc: [null],
      permitMcc: [null],
      produto: [null]
    });
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.spinnerService.show();
    this.service.buscaProdutos().subscribe((response) => {

      let arr = JSON.parse(JSON.stringify(response));
      arr.forEach(element => {
        if (element.produtoDescricao == 'VIAGEM') element.produtoDescricao = 'DESPESAS';
        if (element.produtoDescricao == 'ALIMENTACAO_BANDEIRADO') element.produtoDescricao = 'ALIMENTAÇÃO BANDEIRADO';
        if (element.produtoDescricao == 'REFEICAO_BANDEIRADO') element.produtoDescricao = 'REFEIÇÃO BANDEIRADO';
      });
      let orderedList = arr.sort(function (a, b) {
        if (a.produtoDescricao < b.produtoDescricao) {
          return -1;
        }
        if (a.produtoDescricao > b.produtoDescricao) {
          return 1;
        }
        return 0;
      });

      this.formMccCliente.controls['produto'].setValue(orderedList[orderedList.length - 1].produtoId);
      this.listProdutos = orderedList;

      this.fillBoxes();
    }, (error) => {
      this.spinnerService.hide();
      this.notifications.error(error.message);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
  }

  fillBoxes() {
    let params = new HttpParams();
    params = params.append('productId',
      this.formMccCliente.controls['produto'].value);

    this.service.buscaRestricoes(
      params,
      (response) => {

        this.blocked = response.blocked;
        this.unblocked = response.unblocked;
        let groupBlocked = this.groupByMcc(this.mapGroup(this.blocked));
        let groupUnblocked = this.groupByMcc(this.mapGroup(this.unblocked));
        this.resetedBlocked = this.resetFlatList(groupBlocked);
        this.resetedUnblocked = this.resetFlatList(groupUnblocked);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });
  }

  mapGroup(unmappedGrp) {
    let mappedGrp = [];
    unmappedGrp.forEach((element) => {
      mappedGrp.push({
        id: element.grupoId,
        grupo: {
          id: element.grupoId,
          nomeGrupo: element.nomeGrupo,
        },
        mcc: {
          id: element.mccId,
          descricao: element.descricao,
          mcc: element.mcc,
          mccGrupo: element.mccGrupo,
        },
      });
    });
    return mappedGrp;
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  buscaMcc(mcc) {
    let params = new HttpParams();
    params = params.append('productId',
      this.formMccCliente.controls['produto'].value);
    if (mcc != null && mcc.trim().length != 0) {
      params = params.append('descricao', mcc);
    }
    this.spinnerService.show();
    this.service.buscaRestricoes(
      params,
      (response) => {
        this.blocked = response.blocked;
        this.unblocked = response.unblocked;
        let groupBlocked = this.groupByMcc(this.mapGroup(this.blocked));
        let groupUnblocked = this.groupByMcc(this.mapGroup(this.unblocked));
        this.resetedBlocked = this.resetFlatList(groupBlocked);
        this.resetedUnblocked = this.resetFlatList(groupUnblocked);
        this.checkedUnblockedList.splice(0, this.checkedUnblockedList.length);
        this.checkedBlockedList.splice(0, this.checkedBlockedList.length);
        this.spinnerService.hide();
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });

  }

  resetFlatList(group) {
    let flatList = [];
    for (let list of group) {
      flatList.push({
        type: 'G',
        id: list.id,
        groupId: list.id,
        descricao: list.descricao,
      });
      for (let mccList of list.mcc) {
        flatList.push({
          type: 'M',
          id: mccList.mcc,
          descricao: mccList.descricao,
          groupId: list.id,
          groupDescricao: list.descricao,
          mccId: mccList.id,
          mccGrupo: mccList.mccGrupo,
        });
      }
    }
    return flatList;
  }

  save() {

    let temp = JSON.parse(JSON.stringify(this.resetedBlocked));
    let duplicatedRestricaoId = [];
    let uniqueRestricaoId = [];
    let restricaoIds = [];
    temp.forEach(element => {
      if (element.mccId != null) {
        duplicatedRestricaoId.push(element.mccId);
      }
    });

    let mccMap = temp
      .filter(e => e.mccId != null)
      .map(e => ({
        restricaoId: e.mccId,
        mccGrupo: e.mccGrupo
      }));

    uniqueRestricaoId = Array.from(new Set(duplicatedRestricaoId));

    uniqueRestricaoId.forEach(v => {
      restricaoIds.push({'restricaoId': v});
    });

    let obj = {
      'produtoId': this.formMccCliente.controls['produto'].value,
      'restricaoMcc': Array.from(mccMap.values())
    };
    this.spinnerService.show();
    this.service.salvaRestricoes(
      obj,
      (response) => {
        this.checkedUnblockedList.splice(0, this.checkedUnblockedList.length);
        this.buscaMcc(null);
        this.notifications.success('Mccs restringidos com sucesso');
        this.formMccCliente.controls['inpMcc'].setValue(null);
      }, (error) => {
        this.spinnerService.hide();
        this.notifications.error(error.message);
      });
  }

  groupByMcc(mccGroup) {
    return groupBy(mccGroup, (mccG) => mccG.grupo.id);
  }

  addAll() {
    let groups = this.getActiveOrAllGroups(this.resetedUnblocked);
    let mccs = this.collectMccsFromGroups(groups, this.resetedUnblocked);
  
    groups.forEach(g => g.active = false);
    mccs.forEach(m => m.active = false);
  
    this.moveItemsToList(groups, this.resetedBlocked);

    const mccGroupIds = new Set(mccs.map(m => m.groupId));

    mccGroupIds.forEach(groupId => {
      const alreadyInBlocked = this.resetedBlocked.some(g => g.type === 'G' && g.groupId === groupId);
      if (!alreadyInBlocked) {
        const groupItem = this.resetedUnblocked.find(g => g.type === 'G' && g.groupId === groupId);
        if (groupItem) {
          this.resetedBlocked.push(JSON.parse(JSON.stringify(groupItem)));
        }
      }
    });
  
    mccs.forEach(mcc => {
      const exists = this.resetedBlocked.some(
        x => x.type === 'M' && x.groupId === mcc.groupId && x.mccId === mcc.mccId
      );
      if (!exists) {
        const idx = this.resetedBlocked.findIndex(
          x => x.type === 'G' && x.groupId === mcc.groupId
        );
        if (idx !== -1) {
          this.resetedBlocked.splice(idx + 1, 0, JSON.parse(JSON.stringify(mcc)));
        }
      }
    });
  
    const itemsToRemove = [...groups, ...mccs];
    const listIdxToRemove = this.getIndexesOfItems(itemsToRemove, this.resetedUnblocked);
    listIdxToRemove.sort((a, b) => b - a).forEach(idx => this.resetedUnblocked.splice(idx, 1));
    this.removerGruposVazios(this.resetedUnblocked);
  
    this.checkedUnblockedList.length = 0;
  }

  private getActiveOrAllGroups(list) {
    const active = list.filter(item => item.active && item.type === 'G');
    return active.length ? active : list.filter(item => item.type === 'G');
  }

  private collectMccsFromGroups(groups, sourceList) {
    let mccs: any[] = [];

    for (let group of groups) {
      const found = sourceList.filter(
        item => item.type === 'M' && item.groupId === group.groupId
      );
      mccs.push(...found.map(x => JSON.parse(JSON.stringify(x))));
    }

  const uniqueMccIds = Array.from(new Set(mccs.map(m => m.mccId)));

    const additionalMccs = sourceList.filter(item =>
      item.type === 'M' && uniqueMccIds.includes(item.mccId)
    );

    const allMccsMap = new Map();
    [...mccs, ...additionalMccs].forEach(m => {
      const key = `${m.groupId}-${m.mccId}`;
      if (!allMccsMap.has(key)) {
        allMccsMap.set(key, JSON.parse(JSON.stringify(m)));
      }
    });

    return Array.from(allMccsMap.values());
  }

  
  private getIndexesOfItems(items, sourceList) {
    return items
      .map(item => sourceList.findIndex(x =>
        x.type === item.type &&
        x.groupId === item.groupId &&
        (item.type === 'G' || x.mccId === item.mccId)
      ))
      .filter(idx => idx !== -1);
  }
  
  private moveItemsToList(items, targetList) {
    for (let item of items) {
      const exists = targetList.some(x =>
        x.type === item.type &&
        x.groupId === item.groupId &&
        (item.type === 'G' || x.mccId === item.mccId)
      );
      if (!exists) {
        targetList.push(JSON.parse(JSON.stringify(item)));
      }
    }
  }

  add() {
    this.transferRestrictions(
      this.checkedUnblockedList,
      this.resetedUnblocked,
      this.resetedBlocked
    );
    this.checkedUnblockedList.length = 0;
  }

  remove() {
    this.transferRestrictions(
      this.checkedBlockedList,
      this.resetedBlocked,
      this.resetedUnblocked
    );
    this.checkedBlockedList.length = 0;
  }

  private transferRestrictions(
    checkedList: any[],
    sourceList: any[],
    targetList: any[]
  ) {
    const restrictionsToMove = this.getRestrictionsToMove(checkedList, sourceList);
    const groupsToEnsure = this.getGroupsToEnsure(restrictionsToMove, sourceList, targetList);
    const indexesToRemove = this.prepareTransfer(
      restrictionsToMove,
      groupsToEnsure,
      sourceList,
      targetList
    );

    indexesToRemove.sort((a, b) => b - a).forEach(idx => sourceList.splice(idx, 1));
  }

  private getRestrictionsToMove(checkedList: any[], sourceList: any[]) {
    return sourceList.filter(i =>
      checkedList.some(item => item.mccId === i.mccId && i.type === 'M')
    );
  }

  private getGroupsToEnsure(restrictions: any[], sourceList: any[], targetList: any[]) {
    const groups: any[] = [];

    for (let r of restrictions) {
      const group = sourceList.find(x => x.type === 'G' && x.groupId === r.groupId);
      if (group && !targetList.some(x => x.type === 'G' && x.groupId === group.groupId)) {
        groups.push(JSON.parse(JSON.stringify(group)));
      }
    }

    for (let g of groups) {
      targetList.push(JSON.parse(JSON.stringify(g)));
    }

    return groups;
  }

  private prepareTransfer(
    restrictions: any[],
    groups: any[],
    sourceList: any[],
    targetList: any[]
  ): number[] {
    const indexesToRemove: number[] = [];
    const mccsToRemove = this.processRestrictions(restrictions, sourceList, targetList, indexesToRemove);
    this.handleGroupRemovals(groups, sourceList, mccsToRemove, indexesToRemove);
    return indexesToRemove;
  }

  private processRestrictions(
    restrictions: any[],
    sourceList: any[],
    targetList: any[],
    indexesToRemove: number[]
  ): any[] {
    const mccsToRemove: any[] = [];

    for (const r of restrictions) {
      r.active = false;
      if (r.checked) delete r.checked;

      this.insertIntoTargetIfNotExists(r, targetList);
      this.addToRemoveListIfExists(r, sourceList, indexesToRemove, mccsToRemove);
    }

    return mccsToRemove;
  }

  private insertIntoTargetIfNotExists(r: any, targetList: any[]) {
    const hasGroup = targetList.some(x => x.type === 'G' && x.groupId === r.groupId);
    const hasMcc = targetList.some(x => x.type === 'M' && x.groupId === r.groupId && x.mccId === r.mccId);

    if (!hasMcc && hasGroup) {
      const idxGroup = targetList.findIndex(x => x.type === 'G' && x.groupId === r.groupId);
      if (idxGroup !== -1) {
        targetList.splice(idxGroup + 1, 0, JSON.parse(JSON.stringify(r)));
      }
    }
  }

  private addToRemoveListIfExists(r: any, sourceList: any[], indexesToRemove: number[], mccsToRemove: any[]) {
    const idx = sourceList.findIndex(x => x.type === 'M' && x.groupId === r.groupId && x.mccId === r.mccId);
    if (idx !== -1) {
      indexesToRemove.push(idx);
      mccsToRemove.push(r);
    }
  }

  private handleGroupRemovals(groups: any[], sourceList: any[], mccsToRemove: any[], indexesToRemove: number[]) {
    for (const group of groups) {
      const allItems = sourceList.filter(x => x.groupId === group.groupId);
      const mccCount = allItems.filter(x => x.type === 'M').length;
      const removedMccCount = mccsToRemove.filter(x => x.groupId === group.groupId).length;

      const hasGroup = allItems.some(x => x.type === 'G');
      if (hasGroup && mccCount === removedMccCount) {
        const idx = sourceList.findIndex(x => x.type === 'G' && x.groupId === group.groupId);
        if (idx !== -1) {
          indexesToRemove.push(idx);
        }
      }
    }
  }

  removeAll() {
    const groups = this.getActiveOrAllGroups(this.resetedBlocked);
    const mccs = this.collectMccsFromGroups(groups, this.resetedBlocked);

    this.desativarItens([...groups, ...mccs]);
    this.adicionarGruposNaListaSeNecessario(mccs, this.resetedBlocked, this.resetedUnblocked);
    this.inserirMccsNaLista(mccs, this.resetedUnblocked);

    this.removerItensDaLista(mccs, this.resetedBlocked);
    this.removerGruposVazios(this.resetedBlocked);

    this.checkedBlockedList.length = 0;
  }

  private desativarItens(itens: any[]) {
    itens.forEach(i => i.active = false);
  }

  private adicionarGruposNaListaSeNecessario(mccs: any[], origem: any[], destino: any[]) {
    const mccGroupIds = new Set(mccs.map(m => m.groupId));
    mccGroupIds.forEach(groupId => {
      const jaExiste = destino.some(g => g.type === 'G' && g.groupId === groupId);
      if (!jaExiste) {
        const grupo = origem.find(g => g.type === 'G' && g.groupId === groupId);
        if (grupo) {
          destino.push(JSON.parse(JSON.stringify(grupo)));
        }
      }
    });
  }

  private inserirMccsNaLista(mccs: any[], destino: any[]) {
    mccs.forEach(mcc => {
      const existe = destino.some(
        x => x.type === 'M' && x.groupId === mcc.groupId && x.mccId === mcc.mccId
      );
      if (!existe) {
        const idx = destino.findIndex(x => x.type === 'G' && x.groupId === mcc.groupId);
        if (idx !== -1) {
          destino.splice(idx + 1, 0, JSON.parse(JSON.stringify(mcc)));
        }
      }
    });
  }

  private removerItensDaLista(itens: any[], lista: any[]) {
    const indices = this.getIndexesOfItems(itens, lista);
    indices.sort((a, b) => b - a).forEach(idx => lista.splice(idx, 1));
  }

  private removerGruposVazios(lista: any[]) {
    const grupos = lista.filter(x => x.type === 'G');
    for (const grupo of grupos) {
      const mccsDoGrupo = lista.filter(x => x.type === 'M' && x.groupId === grupo.groupId);
      if (mccsDoGrupo.length === 0) {
        const idx = lista.findIndex(x => x.type === 'G' && x.groupId === grupo.groupId);
        if (idx !== -1) {
          lista.splice(idx, 1);
        }
      }
    }
  }


  selectedUnblocked(itemSelected) {

    for (let item of this.resetedBlocked) {
      item.active = false;
    }
    itemSelected.active = true;
  }

  selectedBlocked(itemSelected) {
    for (let item of this.resetedBlocked) {
      if (item.active) {
        item.active = false;
      }
    }
    itemSelected.active = true;
  }

  changeCheckboxBlocked(event, item) {

    if (event.target.checked) {
      let filteredCheckList = this.checkedBlockedList.filter(
        (i) => item.id == i.id
      );
      for (let i = 0; i < this.checkedBlockedList.length; i++) {
        if (filteredCheckList && this.checkedBlockedList[i].id == item.id) {
          this.checkedBlockedList[i].checked++;
        }
      }
      item.checked = 1;
      if (filteredCheckList.length == 0) this.checkedBlockedList.push(item);
    } else {
      let idx = this.checkedBlockedList.findIndex((x) => x.id === item.id);
      if (this.checkedBlockedList[idx].checked > 1)
        this.checkedBlockedList[idx].checked--;
      else this.checkedBlockedList.splice(idx, 1);
    }
  }

  changeCheckboxUnblocked(event, item) {
    if (event.target.checked) {
      let filteredCheckList = this.checkedUnblockedList.filter(
        (i) => item.id == i.id
      );
      for (let i = 0; i < this.checkedUnblockedList.length; i++) {
        if (filteredCheckList && this.checkedUnblockedList[i].id == item.id) {
          this.checkedUnblockedList[i].checked++;
        }
      }
      item.checked = 1;
      if (filteredCheckList.length == 0) this.checkedUnblockedList.push(item);
    } else {
      let idx = this.checkedUnblockedList.findIndex((x) => x.id === item.id);
      if (this.checkedUnblockedList[idx].checked > 1)
        this.checkedUnblockedList[idx].checked--;
      else this.checkedUnblockedList.splice(idx, 1);
    }
  }
}

function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      let mergArr = item.grupo;
      mergArr.descricao = item.grupo.nomeGrupo;
      mergArr.mcc = [item.mcc];
      map.set(key, [mergArr]);
    } else {
      collection[0].mcc.push(item.mcc);
      map.set(key, collection);
    }
  });
  return Array.from(map.values()).map(function (i) {
    return i[0];
  });
}
